import React, { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { useNavigate, useLocation } from 'react-router-dom'

export default function LoginPage() {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState(null)
  const [showPass, setShowPass] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const handleSubmit = async (e) => {
    if (e) e.preventDefault()
    if (!username || !password) {
      setModal({ type: 'warning', title: 'กรุณากรอกข้อมูล', message: 'กรุณากรอก Username และ Password' })
      return
    }
    setLoading(true)
    try {
      const result = await login(username, password)
      if (result && result.success) { navigate('/'); return }
      const msg = result.message || 'เกิดข้อผิดพลาด'
      if (msg.includes('ถูกล็อค')) {
        setModal({ type: 'lock', title: 'บัญชีถูกล็อค', message: msg })
      } else if (msg.includes('ปิดใช้งาน')) {
        setModal({ type: 'lock', title: 'บัญชีถูกปิดใช้งาน', message: msg })
      } else {
        setModal({ type: 'error', title: 'เข้าสู่ระบบไม่สำเร็จ', message: msg })
      }
    } catch (err) {
      setModal({ type: 'error', title: 'เกิดข้อผิดพลาด', message: 'ไม่สามารถติดต่อเซิร์ฟเวอร์ได้' })
    } finally {
      setLoading(false)
    }
  }

  const handleKeyDown = (e, nextId) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      if (nextId) document.getElementById(nextId)?.focus()
      else handleSubmit()
    }
  }

  const config = {
    error:   { bg: '#dc2626', icon: '❌' },
    warning: { bg: '#f97316', icon: '⚠️' },
    lock:    { bg: '#991b1b', icon: '🔒' }
  }

  return (
    <div className="login-page" style={{ minHeight: '100vh', display: 'flex', background: '#f3f8ff' }}>
      {location.state?.passwordChanged && <p role="status" style={{ position: 'fixed', zIndex: 2, top: 12, right: 12, background: '#ecfdf5', color: '#065f46', padding: '12px', borderRadius: '8px' }}>ตั้งรหัสผ่านใหม่สำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง</p>}

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 99999, padding: '16px' }}>
          <div style={{ background: 'white', borderRadius: '20px', width: '100%', maxWidth: '340px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <div style={{ background: config[modal.type]?.bg, padding: '28px', textAlign: 'center' }}>
              <div style={{ fontSize: '44px', marginBottom: '10px' }}>{config[modal.type]?.icon}</div>
              <h3 style={{ fontSize: '18px', fontWeight: '500', color: 'white', margin: 0 }}>{modal.title}</h3>
            </div>
            <div style={{ padding: '20px' }}>
              <p style={{ fontSize: '13px', color: '#4b5563', textAlign: 'center', lineHeight: '1.6', marginBottom: '16px' }}>{modal.message}</p>
              {modal.type === 'lock' && (
                <p style={{ fontSize: '12px', color: '#ef4444', textAlign: 'center', marginBottom: '12px' }}>กรุณาติดต่อผู้ดูแลระบบ IT เพื่อปลดล็อค</p>
              )}
              <button onClick={() => setModal(null)}
                style={{ width: '100%', padding: '10px', background: config[modal.type]?.bg, color: 'white', border: 'none', borderRadius: '12px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                ตกลง
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Left Panel */}
      <div className="login-desktop-panel" style={{ flex: '0 0 58%', background: 'linear-gradient(135deg, #063b91 0%, #075dcc 52%, #1594df 100%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', width: '400px', height: '400px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)', top: '-100px', right: '-100px' }} />
        <div style={{ position: 'absolute', width: '250px', height: '250px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)', bottom: '-80px', left: '-80px' }} />
        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <div style={{ width: '72px', height: '72px', background: 'rgba(255,255,255,0.12)', borderRadius: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px', border: '0.5px solid rgba(255,255,255,0.15)' }}>
            <svg style={{ width: '36px', height: '36px', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h1 style={{ fontSize: '20px', fontWeight: '500', color: 'white', marginBottom: '8px', whiteSpace: 'nowrap'}}>ระบบบริหารจัดการสัญญาจ้างของพนักงานจ้าง</h1>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.5)', lineHeight: '1.6' }}>เทศบาลนครมาบตาพุด<br />จังหวัดระยอง</p>
          <div style={{ marginTop: '48px', display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '280px', margin: '48px auto 0' }}>
            {[
              { icon: '🔒', title: 'ระบบปลอดภัย', desc: 'เข้ารหัสข้อมูลทุกขั้นตอน' },
              { icon: '✍️', title: 'ลงนามดิจิทัล', desc: 'รองรับลายเซ็นอิเล็กทรอนิกส์' },
              { icon: '📱', title: 'ใช้งานได้ทุกอุปกรณ์', desc: 'รองรับมือถือและแท็บเล็ต' },
            ].map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{ width: '38px', height: '38px', background: 'rgba(255,255,255,0.1)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px', flexShrink: 0 }}>{f.icon}</div>
                <div>
                  <p style={{ fontSize: '13px', fontWeight: '500', color: 'white' }}>{f.title}</p>
                  <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.4)' }}>{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="login-form-panel" style={{ flex: '0 0 40%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '40px 32px', background: 'white' }}>
        {/* Mobile Logo */}
        <div className="login-mobile-brand" style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ width: '56px', height: '56px', background: '#075dcc', borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px', boxShadow: '0 10px 24px rgba(7,93,204,.22)' }}>
            <svg style={{ width: '28px', height: '28px', color: 'white' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h1 style={{ fontSize: '18px', fontWeight: '500', color: '#0f172a' }}>ระบบบริหารจัดการสัญญาจ้างของพนักงานจ้าง</h1>
          <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>เทศบาลนครมาบตาพุด</p>
        </div>

        <div className="login-form-card" style={{ width: '100%', maxWidth: '360px' }}>
          <div style={{ marginBottom: '32px' }}>
            <h2 style={{ fontSize: '22px', fontWeight: '500', color: '#0f172a', marginBottom: '6px' }}>เข้าสู่ระบบ</h2>
            <p style={{ fontSize: '13px', color: '#94a3b8' }}>กรอกข้อมูลผู้ใช้งานของท่าน</p>
          </div>

          <form onSubmit={handleSubmit} autoComplete="off">
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>ชื่อผู้ใช้</label>
              <div style={{ position: 'relative' }}>
                <svg style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#94a3b8' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <input id="username-input" type="text" value={username}
                  onChange={e => setUsername(e.target.value)}
                  onKeyDown={e => handleKeyDown(e, 'password-input')}
                  placeholder="กรอก username"
                  style={{ width: '100%', padding: '10px 12px 10px 38px', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', color: '#0f172a', background: '#f8fafc', outline: 'none', fontFamily: 'inherit' }} />
              </div>
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>รหัสผ่าน</label>
              <div style={{ position: 'relative' }}>
                <svg style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', width: '16px', height: '16px', color: '#94a3b8' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <input id="password-input" type={showPass ? 'text' : 'password'} value={password}
                  onChange={e => setPassword(e.target.value)}
                  onKeyDown={e => handleKeyDown(e, null)}
                  placeholder="กรอก password"
                  style={{ width: '100%', padding: '10px 40px 10px 38px', border: '0.5px solid #e2e8f0', borderRadius: '10px', fontSize: '13px', color: '#0f172a', background: '#f8fafc', outline: 'none', fontFamily: 'inherit' }} />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', padding: 0 }}>
                  <svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {showPass
                      ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                      : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    }
                  </svg>
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className="ui-shine-button"
              style={{ width: '100%', padding: '11px', background: loading ? '#93bdea' : 'linear-gradient(100deg, #075dcc, #167fd8)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: '600', cursor: loading ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontFamily: 'inherit', transition: 'background 0.15s', boxShadow: '0 10px 22px rgba(7,93,204,.2)' }}>
              {loading ? (
                <><svg style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} fill="none" viewBox="0 0 24 24"><circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" /><path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8v8z" /></svg>กำลังเข้าสู่ระบบ...</>
              ) : (
                <><svg style={{ width: '16px', height: '16px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" /></svg>เข้าสู่ระบบ</>
              )}
            </button>
          </form>

          <div style={{ marginTop: '20px', background: '#eff6ff', borderRadius: '10px', padding: '12px 14px', display: 'flex', gap: '10px' }}>
            <svg style={{ width: '16px', height: '16px', color: '#075dcc', flexShrink: 0, marginTop: '1px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p style={{ fontSize: '11px', color: '#174989', lineHeight: '1.5' }}>หากลืมรหัสผ่านหรือบัญชีถูกล็อค กรุณาติดต่อผู้ดูแลระบบ IT</p>
          </div>

          <p style={{ textAlign: 'center', fontSize: '11px', color: '#cbd5e1', marginTop: '24px' }}>
            ระบบบริหารจัดการสัญญาจ้างของพนักงานจ้างแบบอิเล็กทรอนิกส์เทศบาลนครมาบตาพุด © 2568
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }
        .login-mobile-brand { display: none; }
        @media (max-width: 959px) {
          .login-page {
            width: 100%;
            min-height: 100svh !important;
            overflow-x: hidden;
            background: linear-gradient(180deg, #eaf4ff 0%, #ffffff 38%) !important;
          }
          .login-desktop-panel { display: none !important; }
          .login-form-panel {
            flex: 1 1 100% !important;
            width: 100% !important;
            min-width: 0;
            min-height: 100svh;
            justify-content: flex-start !important;
            padding: max(28px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom)) !important;
            background: transparent !important;
          }
          .login-mobile-brand {
            display: block;
            margin: 18px 0 26px !important;
          }
          .login-form-card {
            max-width: 420px !important;
            padding: 24px 20px 20px;
            border: 1px solid #e2e8f0;
            border-radius: 20px;
            background: rgba(255,255,255,0.96);
            box-shadow: 0 18px 45px rgba(30,41,59,0.09);
          }
          .login-form-card input { min-height: 48px; font-size: 16px !important; }
          .login-form-card button[type='submit'] { min-height: 48px; font-size: 15px !important; }
        }
        @media (max-width: 380px) {
          .login-form-panel { padding-left: 14px !important; padding-right: 14px !important; }
          .login-form-card { padding: 20px 16px 18px; border-radius: 16px; }
          .login-mobile-brand { margin-top: 8px !important; margin-bottom: 18px !important; }
        }
      `}</style>
    </div>
  )
}
